/* elv-cart-tier.js — 2026-10-17. Cart-aware prices everywhere.
   Reads #elv-cart-tier (snippets/elv-cart-tier.liquid: accessories + trackers already in the cart), then:
     - collection / search / related cards: shows the price this item will ACTUALLY be at checkout given the cart
       (struck original, "−10% with your cart") and the price after one more ("with one more: … −15%");
     - a strip at the top of a collection saying what the cart already unlocks;
     - a product page without the set picker (charger, sleeve): same struck price under the title;
     - the "Complete your set" row on the cart page: one-tap add, then Dawn re-renders the cart.
   Every figure mirrors a live automatic discount; Shopify applies the same one at checkout. */
(function () {
  'use strict';
  var AR = document.documentElement.lang === 'ar';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var T = {
    withCart: AR ? 'عند إضافته' : 'when added',
    oneMore: AR ? 'مع قطعة أخرى' : 'with one more',
    each: AR ? 'على كل جهاز' : 'each',
    added: AR ? 'تمت الإضافة' : 'Added',
    add: AR ? 'أضِف' : 'Add',
    fail: AR ? 'تعذّرت الإضافة، حاول مرة أخرى.' : 'Could not add — please try again.'
  };
  function money(c) { return 'EGP ' + Math.round(c / 100).toLocaleString('en-US'); }
  /* 2026-10-18 owner: with a tracker the band ladder starts at 10% (1 band) and is 15% from 2 bands */
  function accPct(nAcc, nTrk) { if (nTrk >= 1) { return nAcc >= 2 ? 15 : (nAcc === 1 ? 10 : 0); } return nAcc >= 3 ? 15 : (nAcc === 2 ? 10 : 0); }
  function trkOff(nTrk) { return nTrk >= 3 ? 74900 : (nTrk === 2 ? 49900 : 0); }
  /* Shopify applies ONE automatic discount: the one that saves more in total (checked 2026-10-17: 2 trackers + 1 band ->
     EGP 998 on the trackers, band full price; 2 trackers + 2 bands -> 10% on the bands (1,100), trackers full price).
     best(): for a cart of nAcc accessories worth accSum (cents) and nTrk trackers -> {pct, off, trkWins}. */
  function best(nAcc, nTrk, accSum) {
    /* 2026-10-18: the elvara-offers app applies BOTH (band ladder + tracker pair), so nothing is traded off */
    var pct = accPct(nAcc, nTrk), off = trkOff(nTrk);
    return { pct: pct, off: off, trkWins: off > 0, save: Math.round(accSum * pct / 100) + off * nTrk };
  }

  var tier = { acc: 0, trk: 0, accSum: 0, gen: '', count: 0, handles: [] };
  function read(doc) {
    var el = (doc || document).getElementById('elv-cart-tier');
    if (!el) { return false; }
    try { var j = JSON.parse(el.textContent); tier = { acc: +j.acc || 0, trk: +j.trk || 0, accSum: +j.accSum || 0, gen: j.gen || '', count: +j.count || 0, handles: j.handles || [] }; return true; } catch (e) { return false; }
  }
  read();
  window.elvTier = tier;
  window.elvTierFns = { accPct: accPct, trkOff: trkOff, best: best, money: money };

  /* ---------- the banner on a collection page ---------- */
  function bannerText(hasAcc, hasTrk) {
    var a = tier.acc, t = tier.trk;
    if (hasAcc) {
      if (a >= 3) { return AR ? 'معك أفضل سعر: خصم 15% على كل سوار، بما فيها هذه.' : 'You have our best price: 15% off every band, including these.'; }
      if (a === 2 && t >= 1) { return AR ? 'معك أفضل سعر: خصم 15% على كل سوار، بما فيها هذه.' : 'You have our best price: 15% off every band, including these.'; }
      if (a === 2) { return AR ? 'في سلتك سواران بخصم 10%. أضِف أي سوار من هنا وتصبح الثلاثة بخصم 15%.' : '2 bands in your cart at 10% off. Add any band here and all three become 15% off.'; }
      if (a === 1 && t >= 1) { return AR ? 'في سلتك جهاز وسوار بخصم 10%. أضِف أي سوار من هنا ويصبح الاثنان بخصم 15%.' : 'Tracker and 1 band in your cart at 10% off. Add any band here and both bands become 15% off.'; }
      if (a === 1) { return AR ? 'في سلتك سوار. أضِف أي سوار من هنا: خصم 10% على الاثنين. أضِف اثنين: 15% على الكل.' : '1 band in your cart. Add any band here: 10% off both. Add two: 15% off all of them.'; }
      if (t >= 1) { return AR ? 'في سلتك جهاز. أضِف أي سوار من هنا بخصم 10%. سواران: خصم 15% على الاثنين.' : 'Tracker in your cart. Add any band here at 10% off. Two bands: 15% off both.'; }
    }
    if (hasTrk && t >= 1) {
      if (t >= 3) { return AR ? 'معك أفضل عرض للأجهزة: خصم 749 جنيهًا على كل جهاز.' : 'You have our best offer on trackers: EGP 749 off each.'; }
      if (t === 2) { return AR ? 'جهازان في سلتك — جهاز ثالث يرفع الخصم إلى 749 جنيهًا على كل جهاز.' : '2 trackers in your cart — a third makes it EGP 749 off each.'; }
      return AR ? 'جهاز في سلتك. أضِف جهازًا ثانيًا: خصم 499 جنيهًا على كل جهاز، الأول كذلك.' : 'Tracker in your cart. Add a second: EGP 499 off each, the first one too.';
    }
    return '';
  }

  /* ---------- cards ---------- */
  function paintCards(scope) {
    var cards = (scope || document).querySelectorAll('.elv-cp[data-elv-price]'), hasAcc = false, hasTrk = false;
    Array.prototype.forEach.call(cards, function (cp) {
      var price = parseInt(cp.getAttribute('data-elv-price'), 10) || 0, kind = cp.getAttribute('data-elv-kind');
      var html = '';
      if (kind === 'acc') {
        hasAcc = true;
        var now = best(tier.acc + 1, tier.trk, tier.accSum + price).pct, next = best(tier.acc + 2, tier.trk, tier.accSum + 2 * price).pct;
        if (now > 0) {
          html = '<s dir="ltr">' + money(price) + '</s> <b dir="ltr">' + money(Math.round(price * (100 - now) / 100)) + '</b> <em dir="ltr">−' + now + '%</em> <span class="elv-cp-w">' + T.withCart + '</span>';
          if (next > now) { html += '<small><bdi dir="ltr">' + money(Math.round(price * (100 - next) / 100)) + '</bdi> ' + T.oneMore + ' <bdi dir="ltr">(−' + next + '%)</bdi></small>'; }
        }
      } else if (kind === 'trk') {
        hasTrk = true;
        var bt = best(tier.acc, tier.trk + 1, tier.accSum), off = bt.trkWins ? bt.off : 0;
        if (off > 0) { html = '<s dir="ltr">' + money(price) + '</s> <b dir="ltr">' + money(price - off) + '</b> <em dir="ltr">−' + money(off) + '</em> <span class="elv-cp-w">' + T.withCart + '</span>'; }
      }
      if (cp.innerHTML !== html) { cp.innerHTML = html; }
      if (cp.hidden !== !html) { cp.hidden = !html; }
      var card = cp.closest('.card__information, .card-information, .elv-cs-card');
      if (card) { card.classList.toggle('elv-cp-on', !!html); }
    });
    var b = document.querySelector('.elv-ctb');
    if (b) {
      var txt = bannerText(hasAcc, hasTrk);
      b.innerHTML = txt ? '<span class="elv-ctb-i" aria-hidden="true"></span>' + txt : '';
      b.hidden = !txt;
    }
  }

  /* ---------- a product page without the set picker (charger, sleeve, armband) ---------- */
  function paintProduct() {
    if (document.querySelector('.elp')) { return; }
    var pb = document.querySelector('.product__info-container [id^="price-"][data-elv-price]');
    if (!pb) { return; }
    var price = parseInt(pb.getAttribute('data-elv-price'), 10) || 0, kind = pb.getAttribute('data-elv-kind');
    var el = pb.querySelector('.elv-pp');
    if (!el) { el = document.createElement('div'); el.className = 'elv-pp'; pb.appendChild(el); }
    var html = '';
    if (kind === 'acc') {
      var now = best(tier.acc + 1, tier.trk, tier.accSum + price).pct;
      if (now > 0) { html = '<b dir="ltr">' + money(Math.round(price * (100 - now) / 100)) + '</b> <em dir="ltr">−' + now + '%</em> <span>' + T.withCart + '</span>'; }
    } else if (kind === 'trk') {
      var bt2 = best(tier.acc, tier.trk + 1, tier.accSum), off = bt2.trkWins ? bt2.off : 0;
      if (off > 0) { html = '<b dir="ltr">' + money(price - off) + '</b> <em dir="ltr">−' + money(off) + '</em> <span>' + T.withCart + '</span>'; }
    }
    el.innerHTML = html; el.hidden = !html;
    pb.classList.toggle('elv-pp-on', !!html);
  }

  /* ---------- "Complete your set" on the cart page: add, then let Dawn re-render ---------- */
  function sectionsToRender() {
    var ids = [], ci = document.getElementById('main-cart-items'), cf = document.getElementById('main-cart-footer');
    if (ci && ci.dataset.id) { ids.push(ci.dataset.id); }
    if (cf && cf.dataset.id) { ids.push(cf.dataset.id); }
    ids.push('cart-icon-bubble', 'cart-live-region-text');
    return ids;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-elv-cs-add]');
    if (!b) { return; }
    e.preventDefault();
    if (b.disabled) { return; }
    b.disabled = true; b.classList.add('is-busy');
    var vid = parseInt(b.getAttribute('data-elv-cs-add'), 10);
    fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: sectionsToRender().join(','), sections_url: window.location.pathname }) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.d && res.d.description || 'add'); }
        /* Dawn's cart page has no renderContents (only the drawer has): swap the re-rendered sections ourselves */
        if (!res.d.sections) { window.location.reload(); return; }
        try {
          var sec = res.d.sections, ci = document.getElementById('main-cart-items'), cf = document.getElementById('main-cart-footer');
          function swap(host, html, selector) {
            if (!host || !html) { return; }
            var d = new DOMParser().parseFromString(html, 'text/html');
            var src = d.querySelector(selector), dst = host.querySelector(selector);
            if (src && dst) { dst.innerHTML = src.innerHTML; } else if (src) { host.innerHTML = src.outerHTML; }
          }
          swap(ci, sec[ci && ci.dataset.id], '.js-contents');
          swap(cf, sec[cf && cf.dataset.id], '.js-contents');
          var bub = document.getElementById('cart-icon-bubble');
          if (bub && sec['cart-icon-bubble']) { var bd = new DOMParser().parseFromString(sec['cart-icon-bubble'], 'text/html').querySelector('.shopify-section'); if (bd) { bub.innerHTML = bd.innerHTML; } }
          var cd = document.querySelector('cart-drawer');
          if (cd) { cd.classList.toggle('is-empty', res.d.item_count === 0); }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'elv-cart-complete', cartData: res.d }); }
          refresh();
          var row = document.querySelector('[data-elv-cs]'); if (row) { row.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
        } catch (err) { window.location.reload(); }
      })
      .catch(function () { b.disabled = false; b.classList.remove('is-busy'); b.textContent = T.fail; });
  });

  /* ---------- keep in step with the cart ---------- */
  var busy = false;
  function refresh() {
    if (busy) { return; }
    busy = true;
    fetch(root + '?sections=elv-cart-tier', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j && j['elv-cart-tier']; if (!html) { return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (read(doc)) { window.elvTier = tier; paintAll(); document.dispatchEvent(new CustomEvent('elv:tier', { detail: tier })); }
      }).catch(function () {}).then(function () { busy = false; });
  }
  window.elvTierRefresh = refresh;
  function paintAll() { paintCards(); paintProduct(); }

  function boot() {
    paintAll();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 150); });
    }
    /* the cart page re-renders its items through Dawn: repaint whatever came back */
    /* Our own repaint mutates .elv-cp, which the observer would see again - an endless loop (froze the page
       2026-10-17). Only react to mutations OUTSIDE .elv-cp, and coalesce them into one repaint. */
    var rp = 0;
    function onMut(list, scope) {
      var ours = true;
      for (var i = 0; i < list.length; i++) { var t = list[i].target; if (!(t.closest && t.closest('.elv-cp, .elv-ctb, .elv-pp'))) { ours = false; break; } }
      if (ours) { return; }
      if (rp) { return; }
      rp = requestAnimationFrame(function () { rp = 0; paintCards(scope); });
    }
    var ci = document.getElementById('main-cart-items');
    if (ci && window.MutationObserver) { new MutationObserver(function (l) { onMut(l, ci); }).observe(ci, { childList: true, subtree: true }); }
    /* collection grids re-render on filter / sort / page */
    var pg = document.getElementById('product-grid');
    if (pg && window.MutationObserver) { new MutationObserver(function (l) { onMut(l, null); }).observe(pg.parentNode || pg, { childList: true, subtree: true }); }
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) { refresh(); } });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
